__turbopack_context__.v({
  "blocksBackgroundColor": "calendar-module-scss-module__GSLPPG__blocksBackgroundColor",
  "blocksFontColor": "calendar-module-scss-module__GSLPPG__blocksFontColor",
  "container": "calendar-module-scss-module__GSLPPG__container",
  "contentContainer": "calendar-module-scss-module__GSLPPG__contentContainer",
  "contentTransition": "calendar-module-scss-module__GSLPPG__contentTransition",
  "contentTransitionHeightConstrained": "calendar-module-scss-module__GSLPPG__contentTransitionHeightConstrained",
  "controls": "calendar-module-scss-module__GSLPPG__controls",
  "day": "calendar-module-scss-module__GSLPPG__day",
  "dayContent": "calendar-module-scss-module__GSLPPG__dayContent",
  "dayEvent": "calendar-module-scss-module__GSLPPG__dayEvent",
  "dayEventCurrentlySelectedDate": "calendar-module-scss-module__GSLPPG__dayEventCurrentlySelectedDate",
  "dayEventHidden": "calendar-module-scss-module__GSLPPG__dayEventHidden",
  "dayLabel": "calendar-module-scss-module__GSLPPG__dayLabel",
  "dayPopulated": "calendar-module-scss-module__GSLPPG__dayPopulated",
  "daySelected": "calendar-module-scss-module__GSLPPG__daySelected",
  "dayToday": "calendar-module-scss-module__GSLPPG__dayToday",
  "editButton": "calendar-module-scss-module__GSLPPG__editButton",
  "eventInfo": "calendar-module-scss-module__GSLPPG__eventInfo",
  "eventListContainer": "calendar-module-scss-module__GSLPPG__eventListContainer",
  "eventMeta": "calendar-module-scss-module__GSLPPG__eventMeta",
  "eventTitle": "calendar-module-scss-module__GSLPPG__eventTitle",
  "listControls": "calendar-module-scss-module__GSLPPG__listControls",
  "location": "calendar-module-scss-module__GSLPPG__location",
  "mobileMonthCalendar": "calendar-module-scss-module__GSLPPG__mobileMonthCalendar",
  "monthCalendar": "calendar-module-scss-module__GSLPPG__monthCalendar",
  "scrollAreaWrapper": "calendar-module-scss-module__GSLPPG__scrollAreaWrapper",
  "secondaryNavBackgroundColor": "calendar-module-scss-module__GSLPPG__secondaryNavBackgroundColor",
  "table": "calendar-module-scss-module__GSLPPG__table",
  "th": "calendar-module-scss-module__GSLPPG__th",
  "themeBackgroundColor": "calendar-module-scss-module__GSLPPG__themeBackgroundColor",
  "themeFontColor": "calendar-module-scss-module__GSLPPG__themeFontColor",
  "timeString": "calendar-module-scss-module__GSLPPG__timeString",
  "tr": "calendar-module-scss-module__GSLPPG__tr",
  "transitionAppear": "calendar-module-scss-module__GSLPPG__transitionAppear",
  "transitionAppearActive": "calendar-module-scss-module__GSLPPG__transitionAppearActive",
  "transitionAppearDone": "calendar-module-scss-module__GSLPPG__transitionAppearDone",
  "transitionEnter": "calendar-module-scss-module__GSLPPG__transitionEnter",
  "transitionEnterActive": "calendar-module-scss-module__GSLPPG__transitionEnterActive",
  "transitionEnterDone": "calendar-module-scss-module__GSLPPG__transitionEnterDone",
  "transitionExit": "calendar-module-scss-module__GSLPPG__transitionExit",
  "transitionExitActive": "calendar-module-scss-module__GSLPPG__transitionExitActive",
  "transitionExitDone": "calendar-module-scss-module__GSLPPG__transitionExitDone",
  "viewMoreButton": "calendar-module-scss-module__GSLPPG__viewMoreButton",
});
